import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import SplitText from '../SplitText';
import { Number, getFormattedNumber, FORMAT_MODE } from '../Number';

const validateScore = (score, fullScore) => {
  return numeral(score).value() <= numeral(fullScore).value() ? score : null;
};

const validateFullScore = fullScore => {
  return numeral(fullScore).value() >= 0 ? fullScore : null;
};

const getLeftVariant = compVariant => {
  if (compVariant === 'meds') {
    return FORMAT_MODE.FOUR_DECIMAL;
  }
  if (compVariant === 'rank') {
    return FORMAT_MODE.INTEGER;
  }
  return FORMAT_MODE.TWO_DECIMAL_OPTIONAL;
  // return FORMAT_MODE.OTHER;
};

const getRightVariant = compVariant => {
  // if (compVariant === 'meds') {
  //   return FORMAT_MODE.OTHER;
  // }
  return FORMAT_MODE.TWO_DECIMAL_OPTIONAL;
};

const SplitScore = ({ score, fullScore, variant, color, separator, ...restProps }) => {
  const formattedScore = getFormattedNumber(score, variant);
  const formattedFullScore = getFormattedNumber(fullScore, variant);
  const Left = () => (
    <Number
      value={validateScore(formattedScore, formattedFullScore)}
      variant={getLeftVariant(variant)}
      color={color}
      {...restProps}
    />
  );
  const Right = () => (
    <Number
      value={validateFullScore(formattedFullScore)}
      variant={getRightVariant(variant)}
      color={color}
      {...restProps}
    />
  );

  return (
    <SplitText
      left={<Left />}
      right={<Right />}
      color={color}
      separator={separator}
      {...restProps}
    />
  );
};

SplitScore.propTypes = {
  score: PropTypes.number,
  fullScore: PropTypes.number,
  variant: PropTypes.oneOf(['other', 'meds', 'rank']),
};

export default SplitScore;
